var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPause(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.1086 15.5503V25.3301M16.7737 25.3301V15.5503M35.1108 20.4402C35.1108 22.3666 34.7314 24.2742 33.9942 26.054C33.257 27.8338 32.1764 29.451 30.8142 30.8132C29.452 32.1754 27.8348 33.256 26.055 33.9932C24.2752 34.7304 22.3676 35.1099 20.4412 35.1099C18.5147 35.1099 16.6071 34.7304 14.8273 33.9932C13.0475 33.256 11.4303 32.1754 10.0681 30.8132C8.70593 29.451 7.62537 27.8338 6.88815 26.054C6.15093 24.2742 5.77148 22.3666 5.77148 20.4402C5.77148 16.5495 7.31704 12.8183 10.0681 10.0672C12.8192 7.31606 16.5505 5.77051 20.4412 5.77051C24.3318 5.77051 28.0631 7.31606 30.8142 10.0672C33.5653 12.8183 35.1108 16.5495 35.1108 20.4402Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/pause.d43c7edd68c9fa2848289bf0d1159b49.svg";
export { ForwardRef as ReactComponent };